import { render, staticRenderFns } from "./BuyDocumentListFinal.vue?vue&type=template&id=43a5a774&"
import script from "./BuyDocumentListFinal.vue?vue&type=script&lang=js&"
export * from "./BuyDocumentListFinal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports